export default "__VITE_ASSET__CdTkFZG3__"